import React from "react";
import { withRouter } from "react-router";
import { useLocation } from "react-router-dom";
import Header from "../../Modules/Header";

const ErrorPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get("code") || "UNKNOWN";
  const deleteAllCookies = () => {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + `=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${process.env.REACT_APP_DOMAIN_NAME}`;
    }
  };  
  let message = process.env.REACT_APP_UNKNOWN;
  if (code === process.env.REACT_APP_CODE_NAME) {
    deleteAllCookies();
    message = process.env.REACT_APP_COOKIE_EXPIRED;
  } else if (code === process.env.REACT_APP_IPLANET_VALIDATE_FAILED) {
    message = process.env.REACT_APP_COOKIE_VALIDATION;
  }

  return (
     <main className="before-login ">
            <Header/>   
    
  <div style={{ textAlign: "center", padding: "50px" }}>
            <div className="ligin-form loginForm">
              <div className="form-wrapper">
                <div className="w-100">
                    <h1>Error</h1>
                      <p>{message}</p>
                      <p>Error Code: {code}</p>
                      <span>{process.env.REACT_APP_MESSAGE_USER}</span>
                </div>
                <div></div>
              </div>
            </div>    
    </div>
     </main>
  
  );
};

export default ErrorPage;
